/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import * as React from "react";

export default function XngWithDynamicGoogleMaps(Component: React.ComponentType<any>) {
    return function passPropsOn(props: any) {
        return <ImportGoogleMaps {...props} component={Component} />;
    };
}

class ImportGoogleMaps extends React.Component {
    state = {
        useLoadScript: false,
        GoogleMap: null,
        InfoWindow: null,
        Marker: null,
        Autocomplete: null,
    };
    // XNG-CHANGES SAINC-1353 : Adding Autocomplete to @react-google-maps/api by overriding the original file (withDynamicGoogleMaps.tsx)
    componentDidMount() {
        import(/* webpackChunkName: "googleMapsApi" */ "@react-google-maps/api").then(
            ({ useLoadScript, GoogleMap, InfoWindow, Marker, Autocomplete }) => {
                this.setState({
                    useLoadScript,
                    GoogleMap,
                    InfoWindow,
                    Marker,
                    Autocomplete,
                });
            },
        );
    }

    render() {
        const { component: Component } = this.props as any;
        if (
            !this.state.useLoadScript ||
            !this.state.GoogleMap ||
            !this.state.InfoWindow ||
            !this.state.Marker ||
            !this.state.Autocomplete
        ) {
            return null;
        }

        return <Component {...this.props} {...this.state} />;
    }
}
